import { connect } from 'react-redux';
import Impress from './impress';
import { navigate } from '../reducers/navigator.reducers';

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn
});

const mapDispatchToProps = dispatch => ({
  navigateToLogin: () => dispatch(navigate({route: '/login'})),
  navigateToSignup: () => dispatch(navigate({route: '/signup'})),
  navigateToHome: () => dispatch(navigate({route: '/'})),
});

export default connect(mapStateToProps, mapDispatchToProps)(Impress);



// WEBPACK FOOTER //
// ./src/app/impress/impress.container.js